// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_d3Q","cls2":"UpsellModalRedesign-cls2_S-s UpsellModalRedesign-cls1_d3Q","blank":"UpsellModalRedesign-blank_-Iw"};